/**
 * @velyn-custom — vely-faq.js
 * Ensures the first FAQ accordion opens with a correct measured height via
 * collapsible-row / Motion (same slide pattern as technical features).
 * Does not override click transitions — only runs once on init.
 */
(function () {
  const SECTION_SELECTOR = '.section-vely-faq';

  function ensureOpenHeight(details) {
    const content = details.querySelector('.collapsible-row__content');
    if (!content) return;

    details.classList.add('detail-open');
    details.setAttribute('open', '');

    if (window.Motion && typeof Motion.animate === 'function') {
      Motion.animate(content, { height: 'auto' }, { duration: 0 });
    } else {
      content.style.height = 'auto';
      content.style.overflow = 'hidden';
    }
  }

  function openFirstFaqItem(section) {
    if (!section || section.dataset.velyFaqInit === 'true') return;

    const container = section.querySelector('.faq-container');
    if (!container) return;

    const firstDetails = container.querySelector('details.collapsible-row');
    if (!firstDetails) return;

    section.dataset.velyFaqInit = 'true';

    const applyOpen = () => {
      if (firstDetails.hasAttribute('open') || firstDetails.classList.contains('detail-open')) {
        ensureOpenHeight(firstDetails);
        return;
      }

      // Prefer custom element setter so theme transition() runs (smooth 0.3s).
      if ('open' in firstDetails) {
        firstDetails.open = true;
        return;
      }

      ensureOpenHeight(firstDetails);
    };

    if (customElements.get('collapsible-row')) {
      requestAnimationFrame(applyOpen);
    } else {
      customElements.whenDefined('collapsible-row').then(() => {
        requestAnimationFrame(applyOpen);
      });
    }
  }

  function initAll() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(openFirstFaqItem);
  }

  function resetSection(section) {
    if (!section) return;
    delete section.dataset.velyFaqInit;
    openFirstFaqItem(section);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section =
      event.target?.querySelector?.(SECTION_SELECTOR) ||
      event.target?.closest?.(SECTION_SELECTOR);
    if (section) resetSection(section);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const section =
      event.target?.querySelector?.(SECTION_SELECTOR) ||
      event.target?.closest?.(SECTION_SELECTOR);
    if (section) delete section.dataset.velyFaqInit;
  });
})();
